// OIDC Client
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client'

export const config = (isSilent: boolean = false): UserManagerSettings => {
  
  const ssoAuthority = process.env.REACT_APP_OIDC_AUTHORITY
  const baseHC = process.env.REACT_APP_BASE_URL_HC

  const OIDC_METADATA = {
    issuer: ssoAuthority,
    jwks_uri: `${ssoAuthority}/.well-known/openid-configuration/jwks`,
    authorization_endpoint: `${ssoAuthority}/connect/authorize`,
    "token_endpoint": `${baseHC}/accounts/api/identity/token`,
    "userinfo_endpoint": `${baseHC}/accounts/api/identity/userinfo`,
    end_session_endpoint: `${ssoAuthority}/connect/endsession`,
    check_session_iframe: `${ssoAuthority}/connect/checksession`,
    "revocation_endpoint": `${baseHC}/accounts/api/identity/revocation`,
    introspection_endpoint: `${ssoAuthority}/connect/introspect`,
    device_authorization_endpoint: `${ssoAuthority}/connect/deviceauthorization`,
    backchannel_authentication_endpoint: `${ssoAuthority}/connect/ciba`,
    "frontchannel_logout_supported": true,
    "frontchannel_logout_session_supported": true,
    "backchannel_logout_supported": true,
    "backchannel_logout_session_supported": true,
    "scopes_supported": [
      "openid",
      "profile",
      "verification",
      "api1",
      "offline_access"
    ],
    "claims_supported": [
      "sub",
      "family_name",
      "given_name",
      "middle_name",
      "nickname",
      "preferred_username",
      "profile",
      "picture",
      "website",
      "gender",
      "birthdate",
      "zoneinfo",
      "locale",
      "updated_at",
      "email",
      "email_verified",
      "email_address"
    ],
    "grant_types_supported": [
      "authorization_code",
      "client_credentials",
      "refresh_token",
      "implicit",
      "password",
      "urn:ietf:params:oauth:grant-type:device_code",
      "urn:openid:params:grant-type:ciba"
    ],
    "response_types_supported": [
      "code",
      "token",
      "id_token",
      "id_token token",
      "code id_token",
      "code token",
      "code id_token token"
    ],
    "response_modes_supported": [
      "form_post",
      "query",
      "fragment"
    ],
    "token_endpoint_auth_methods_supported": [
      "client_secret_basic",
      "client_secret_post"
    ],
    "id_token_signing_alg_values_supported": [
      "RS256"
    ],
    "subject_types_supported": [
      "public"
    ],
    "code_challenge_methods_supported": [
      "plain",
      "S256"
    ],
    "request_parameter_supported": true,
    "request_object_signing_alg_values_supported": [
      "RS256",
      "RS384",
      "RS512",
      "PS256",
      "PS384",
      "PS512",
      "ES256",
      "ES384",
      "ES512",
      "HS256",
      "HS384",
      "HS512"
    ],
    "authorization_response_iss_parameter_supported": true,
    "backchannel_token_delivery_modes_supported": [
      "poll"
    ],
    "backchannel_user_code_parameter_supported": true
  }


  return {
    authority: process.env.REACT_APP_OIDC_AUTHORITY,
    metadata: OIDC_METADATA,
    client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
    redirect_uri: isSilent ? process.env.REACT_APP_OIDC_SILENT_REDIRECT_URI : process.env.REACT_APP_OIDC_REDIRECT_URI,
    post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
    response_type: process.env.REACT_APP_OIDC_RESPONSE_TYPE,
    scope: process.env.REACT_APP_OIDC_SCOPE,
    revokeAccessTokenOnSignout: true,
    prompt: "login",
    stateStore: new WebStorageStateStore({
      store: localStorage,
    }),
    userStore: new WebStorageStateStore({
      store: localStorage,
    }),
  }
}
